// pages/Contact.js
import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';

// Iconos SVG
const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/>
  </svg>
);

const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

const LocationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    loading: false,
    success: false,
    error: false,
    message: ''
  });

  // CONFIGURACIÓN FÁCIL - MISMA RUTA QUE PROPERTYDETAIL O PUEDES USAR UNA DIFERENTE
  const API_BASE_URL = 'https://formspree.io/f/xeorzoak'; // ← Puedes usar la misma o crear otra en Formspree

  // Función para enviar el mensaje de contacto
  const sendContactMessage = async (formData) => {
    try {
      setFormStatus({ loading: true, success: false, error: false, message: '' });
      
      const response = await axios.post(API_BASE_URL, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || 'No proporcionado',
        subject: formData.subject,
        message: formData.message,
        _subject: `📧 Contacto Web: ${formData.subject || 'Consulta General'}`,
        _replyto: formData.email,
        _format: 'plain',
        type: 'contact-page'
      }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        timeout: 15000,
      });

      return response.data;
    } catch (error) {
      console.error('Error enviando mensaje:', error);
      throw error;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!formData.name || !formData.email || !formData.message || !formData.subject) {
      setFormStatus({
        loading: false,
        success: false,
        error: true,
        message: 'Por favor completa todos los campos obligatorios (*)'
      });
      return;
    }

    try {
      const dataToSend = {
        ...formData,
        timestamp: new Date().toISOString(),
        page: 'contact'
      };

      const result = await sendContactMessage(dataToSend);
      
      setFormStatus({
        loading: false,
        success: true,
        error: false,
        message: '¡Mensaje enviado correctamente! Nos pondremos en contacto contigo pronto.'
      });

      // Resetear formulario
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });

      // Limpiar mensaje de éxito después de 5 segundos
      setTimeout(() => {
        setFormStatus(prev => ({ ...prev, message: '' }));
      }, 5000);

    } catch (error) {
      let errorMessage = 'Error al enviar el mensaje. Por favor intenta nuevamente.';
      
      if (error.response) {
        // Error del servidor
        errorMessage = error.response.data.message || `Error ${error.response.status}: ${error.response.statusText}`;
      } else if (error.request) {
        // Error de conexión
        errorMessage = 'No se pudo conectar con el servidor. Verifica tu conexión a internet.';
      }
      
      setFormStatus({
        loading: false,
        success: false,
        error: true,
        message: errorMessage
      });
    }
  };

  // Componente para mostrar el estado del formulario
  const FormStatusMessage = () => {
    if (!formStatus.message) return null;

    return (
      <div className={`form-status ${formStatus.success ? 'success' : ''} ${formStatus.error ? 'error' : ''}`}>
        {formStatus.message}
        {formStatus.loading && <div className="loading-spinner"></div>}
      </div>
    );
  };

  return (
    <div className="contact-page">
      <div className="container">
        {/* Header */}
        <div className="contact-header">
          <h1>Contáctanos</h1>
          <p>Estamos aquí para ayudarte a encontrar la propiedad de tus sueños</p>
        </div>

        <div className="contact-content">
          {/* Información de Contacto */}
          <div className="contact-info">
            <div className="info-card">
              <h2>Información de Contacto</h2>
              
              <div className="info-item">
                <div className="info-icon">
                  <LocationIcon />
                </div>
                <div className="info-content">
                  <h3>Oficina Principal</h3>
                  <p>Carrera 53 # 68-270</p>
                  <p>Barrio El Prado, Barranquilla</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <PhoneIcon />
                </div>
                <div className="info-content">
                  <h3>Teléfonos</h3>
                  <p>+57 3147074390</p>
                  <p>+57 3022966560</p>
                  <p>+57 3045530927</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <EmailIcon />
                </div>
                <div className="info-content">
                  <h3>Correo Electrónico</h3>
                  <p>Inmobiliariajdm1@gmail.com</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                  </svg>
                </div>
                <div className="info-content">
                  <h3>Información Legal</h3>
                  <p>Inmobiliaria JDM SAS</p>
                  <p>NIT: 901601317-7</p>
                </div>
              </div>

              <div className="business-hours">
                <h3>Horario de Atención</h3>
                <div className="hours-list">
                  <div className="hour-item">
                    <span>Lunes - Viernes:</span>
                    <span>8:00 AM - 6:00 PM</span>
                  </div>
                  <div className="hour-item">
                    <span>Sábados:</span>
                    <span>9:00 AM - 2:00 PM</span>
                  </div>
                  <div className="hour-item">
                    <span>Domingos:</span>
                    <span>Cerrado</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Mapa */}
            <div className="map-card">
              <h3>Ubicación de Nuestra Oficina</h3>
              <div className="map-container">
                <iframe
                  width="100%"
                  height="400"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight="0"
                  marginWidth="0"
                  src="https://maps.google.com/maps?q=Carrera%2053%20%2368-270%20Barrio%20El%20Prado%20Barranquilla&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  title="Ubicación de Inmobiliaria JDM SAS"
                ></iframe>
              </div>
              <div className="map-address">
                <LocationIcon />
                <span>Carrera 53 # 68-270, Barrio El Prado, Barranquilla</span>
              </div>
            </div>
          </div>

          {/* Formulario de Contacto ACTUALIZADO */}
          <div className="contact-form-section">
            <div className="form-card">
              <h2>Envíanos un Mensaje</h2>
              <p>Completa el formulario y nos pondremos en contacto contigo</p>
              
              <FormStatusMessage />
              
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Nombre Completo *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      disabled={formStatus.loading}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Correo Electrónico *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={formStatus.loading}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Teléfono</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      disabled={formStatus.loading}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Asunto *</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      disabled={formStatus.loading}
                    >
                      <option value="">Selecciona un asunto</option>
                      <option value="consulta">Consulta General</option>
                      <option value="apartamento-401">Apartamento 401</option>
                      <option value="apartamento-602">Apartamento 602</option>
                      <option value="apartamento-702">Apartamento 702</option>
                      <option value="visita">Solicitud de Visita</option>
                      <option value="otro">Otro</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mensaje *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Cuéntanos en qué podemos ayudarte..."
                    required
                    disabled={formStatus.loading}
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={formStatus.loading}
                >
                  {formStatus.loading ? 'Enviando...' : 'Enviar Mensaje'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;